<template>
    <div class="flex-1 d-flex flex-column h-100">
        <div class="flex-1 d-flex flex-column overflow-auto p-4">
            <div class="row align-items-start m-2 gap-2" style="flex: unset">
                <v-btn style="height: auto !important" text color="primary" class="p-0 btn-color-2" @click="openAddSignatureDialog()"
                 v-if="this.userHavePinCode && !enableUserMultipleSignatures">
                    <v-icon>custom-icon mdi-primary-plus-ring</v-icon>{{$t("res_Label_AddNewSignature")}}
                </v-btn>
                <v-btn style="height: auto !important" text color="primary" class="p-0 btn-color-2" @click="openSetPinCodeDialog()"
                 v-else-if="!this.userHavePinCode && !enableUserMultipleSignatures">
                    <v-icon>custom-icon mdi-primary-plus-ring</v-icon>{{$t("res_Label_SetPinCode")}}
                </v-btn>
                <label v-else style="color: red">
                    {{ $t("res_Msgs_UserNoPinCode") }}
                </label>
            </div>
            <v-data-table :mobile-breakpoint="0" class="d-flex flex-column flex-1 order-table" hide-default-footer disable-sort
                :headers="signatureheaders" :items-per-page="10" :items="userSignature.selectedSignatures"
                :loading="loading" loading-text="loading..." :no-data-text="$t('res_Label_NoData')"
                :footer-props="{ 'items-per-page-text': 'Items per page' }" caption=""
                :class="{ 'result_available': userSignature.selectedSignatures.length != 0, 'no-data': userSignature.selectedSignatures.length == 0 }" header-fixed
                fixed-header>
                <template v-slot:item="row" item-key="id">
                    <tr>
                        <td style="display: none">{{ row.item.id }}</td>
                        <td><img id="ItemPreview" :src=row.item.thumbnail></td>
                        <td>{{ row.item.name }}</td>
                        <td>{{ row.item.signerName }}</td>
                        <td>{{ row.item.signerNameAr }}</td>
                        <td>{{ row.item.signerPosition }}</td>
                        <td>{{ row.item.signerPositionAr }}</td>
                        <td>{{ row.item.isDefault }}</td>
                        <td>
                            <div class="onhover-display">
                                <div class="custom-icon-wrapper ma-2">
                                    <v-icon @click="openResizeSignatureDialog(row.item)">mdi-move-resize</v-icon>
                                </div> 
                                <div class="custom-icon-wrapper ma-2">
                                    <v-icon @click="getUserSignature(row.item.id)">custom-icon white-bg edit-icon</v-icon>
                                </div>
                                <div class="custom-icon-wrapper ma-2">
                                    <v-icon @click="deleteUserSignature(row.item.id)">custom-icon white-bg delete-icon</v-icon>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
                <template v-slot:no-data>
                    <v-row class="p-5">
                        <img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
                        <p class="m-0">{{ $t("res_Msgs_AlertNoItemsHere") }}</p>
                    </v-row>
                </template>
            </v-data-table>
        </div>

        <v-card-actions class="gap-2 sticky-actions">
            <v-spacer></v-spacer>
            <v-btn class="light-blue" style="min-width: 100px !important;" @click="close()">{{$t("res_ButtonText_Cancel")}}</v-btn>
        </v-card-actions>

        <v-dialog v-model="showAddSignatureDialog" width="25%" height="30%" persistent>
            <v-card>
                <v-card-title v-if="current_action=='new'">
                    {{ $t("res_Label_AddSignature") }}
                </v-card-title>
                <v-card-title v-if="current_action=='edit'">
                    {{ $t("res_Label_EditSignature") }}
                </v-card-title>
                <v-card-text>
                    <v-row class="my-3 ml-0">
                        <v-col>
                            <label>{{ $t("res_Label_SignatureName") }} <span style="color: red"> *</span></label>
                            <v-text-field solo v-model="userSignature.signatureName"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="my-3 ml-0">
                        <v-col>
                            <label>{{ $t("res_Label_SignerName") }} <span style="color: red"> *</span></label>
                            <v-text-field solo v-model="userSignature.signerName"></v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-row class="my-3 ml-0">
                        <v-col>
                            <label>{{ $t("res_Label_SignerNameAr") }} <span style="color: red"> *</span></label>
                            <v-text-field solo v-model="userSignature.signerNameAr"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="my-3 ml-0">
                        <v-col>
                            <label>{{ $t("res_Label_SignerPosition") }} <span style="color: red"> *</span></label>
                            <v-text-field solo v-model="userSignature.signerPosition"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="my-3 ml-0">
                        <v-col>
                            <label>{{ $t("res_Label_SignerPositionAr") }} <span style="color: red"> *</span></label>
                            <v-text-field solo v-model="userSignature.signerPositionAr"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="my-3 ml-0" v-if="enableUserMultipleSignatures == true">
                        <v-col>
                            <label><span>{{ $t("res_GridHeaders_Profession") }}</span></label> 
                            <v-select :disabled="(enableUserMultipleSignatures && userProfessions == null || userProfessions.length <= 1)" v-model="userProfession" :items="userProfessions" item-text="text" item-value="id" label="" solo return-object></v-select> 
                        </v-col>
                    </v-row>
                    <v-row  class="my-3 ml-0">
                        <v-col>
                            <v-radio-group inline v-model="signature_method" row>
                                <v-radio id="radio_upload" color="#00ae8d" v-bind:label=" $t('res_Radio_Image')" value='1' v-if="radioUpload"></v-radio>
                                <v-radio id="radio_draw" color="#00ae8d" v-bind:label=" $t('res_Radio_Draw')" value='2' v-if="radioDraw"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row class="my-3 ml-0" v-show="signature_method=='1'">
                        <v-col>
                            <label>{{ $t("res_Label_AttachSignature") }} <span style="color: red"> *</span> </label>
                            <v-file-input id="input-file" 
                                style="cursor: pointer;"
                                accept="image/*" 
                                label="" 
                                solo 
                                v-tooltip ="$t('res_Action_Upload')"
                                v-model="userSignature.signatureFile" 
                                @click="showTempCanvas=true"  
                                @change="removeBackgroundColorOnAdd" 
                                :rules="this.userSignature.uploadDocument" 
                                ref="signatureInput"
                                class="upload-control"
                                :clearable="!!userSignature.signatureFile && userSignature.signatureFile.size > 0"
                                hide-details>
                                <template v-slot:selection="{ text }">
                                    <div>
                                        {{ text }}
                                    </div>
                                </template>
                            </v-file-input>
                            <canvas id="signatureCanvas" v-if="showTempCanvas==true" ></canvas>
                            <div style="display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        height: 25vh;"><img id='image-uploaded' style="max-width: 100%;
                                                                                justify-self: center;
                                                                                max-height: 100%;"  :src="imageUploaded" /></div>
                        </v-col>
                    </v-row>
                    <v-row class="my-3 ml-0" v-show="signature_method=='2'">
                        <v-col id="signature_div">
                           
                            <label>{{ $t("res_Label_DrawSignature") }} <span style="color: red">*</span></label>
                            <label><span style="font-weight: bold;font-size: 11px; color: red">{{ $t("res_Label_DrawSignatureToolTip") }}</span></label> 
                            <VueSignaturePad id="signatureModel" width="100%" height="200px" ref="signaturePad" :options="optionsPad" />

                            <vue-cropper class="cropper-SM " id="cropper-SM" ref="cropperSM" :img="option.img" :output-size="option.size" 
                                :output-type="option.outputType" :info="true" :full="option.full" :fixed="fixed" :fixed-number="fixedNumber"
                                :can-move="option.canMove" :can-move-box="option.canMoveBox" :fixed-box="option.fixedBox" :auto-crop="option.autoCrop" 
                                :auto-crop-width="option.autoCropWidth" :auto-crop-height="option.autoCropHeight" :center-box="option.centerBox"
                                @real-time="realTime" :high="option.high" @img-load="imgLoad" mode="cover" :max-img-size="option.max" 
                                @crop-moving="cropMoving"></vue-cropper>

                            <div > 
                                <img id='image-to-crop-SM'/>
                            </div>

                            <v-spacer></v-spacer>
                            <v-btn width="100" id="crop-btn-SM" class="primary white--text mt-4 btn-sm" @click="convertToImage()">{{$t("res_ButtonText_Crop")}}</v-btn>
                            <v-btn width="100" id="done-btn-SM" class="primary white--text mt-4 btn-sm" @click="finish2()">{{$t("res_ButtonText_Done")}}</v-btn>              
                            <v-btn width="100" id="clear-btn-SM" class="primary white--text mt-4 ml-4 mr-4 btn-sm" @click="resetCanvas()">{{$t("res_ButtonText_Clear")}}</v-btn> 
                        </v-col>
                    </v-row>

                    <v-row class="my-3 ml-0">
                        <v-checkbox v-model="userSignature.isDefault" color="#00ae8d" :label='$t("res_Label_IsDefault")'></v-checkbox>
                    </v-row>
                </v-card-text> 
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="white" width="100" class="black--text" @click="closeAddEditDialog">{{$t("res_ButtonText_Cancel")}}</v-btn>

                    <v-btn width="100" v-if="current_action=='new'" class="primary white--text" :loading="isSubmitting" :disabled="isSubmitting" @click="addUserSignature()">{{$t("res_ButtonText_Submit")}}</v-btn>
                    <v-btn width="100" v-if="current_action=='edit'" class="primary white--text" :loading="isSubmitting" :disabled="isSubmitting" @click="editUserSignature()">{{$t("res_ButtonText_Submit")}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="EditSignatureDialog" width="25%" height="30%">
            <v-card>
                <v-card-title>
                    {{ $t("res_Label_EditSignature") }}
                </v-card-title>
                <v-card-text>
                    <v-row class="my-3 ml-3">
                        <v-col>
                            <label>{{ $t("res_Label_SignatureName") }} <span style="color: red"> *</span></label>
                            <v-text-field solo v-model="editSignature.signatureName"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row  class="my-3 ml-3">
                        <v-col>
                            <v-radio-group inline v-model="signature_method" :value="signature_method" row>
                                <v-radio color="#00ae8d" checked="radioUpload" v-bind:label=" $t('res_Radio_Image')" value='1' ></v-radio>
                                <v-radio color="#00ae8d" checked="radioDraw" v-bind:label=" $t('res_Radio_Draw')" value='2'></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row class="my-3 ml-3" v-if="signature_method=='1'">
                        <v-col>
                            <label>{{ $t("res_Label_AttachSignature") }} </label>
                            <v-file-input id="input-file" accept="image/*" label="" solo v-model="editSignature.signatureFile"
                                :rules="this.editSignature.uploadDocument"
                                :clearable="!!editSignature.signatureFile && editSignature.signatureFile.size > 0">
                            </v-file-input>
                        </v-col>
                    </v-row>
                    
                    <v-row class="my-3 ml-3" v-if="signature_method=='2'">
                        <v-col>
                            <label>{{ $t("res_Label_DrawSignature") }} <span style="color: red">*</span></label>
                            <label><span style="font-weight: bold;font-size: 11px; color: red">{{ $t("res_Label_DrawSignatureToolTip") }}</span></label> 
                            
                            <VueSignaturePad id="signatureModel2" width="100%" height="200px" ref="signaturePad" :options="optionsPad" />
                            
                            <vue-cropper class="cropper-SM " id="cropper-SM2" ref="cropperSM" :img="option.img" :output-size="option.size" 
                            :output-type="option.outputType" :info="true" :full="option.full" :fixed="fixed" :fixed-number="fixedNumber" 
                            :can-move="option.canMove" :can-move-box="option.canMoveBox" :fixed-box="option.fixedBox" :auto-crop="option.autoCrop" 
                            :auto-crop-width="option.autoCropWidth" :auto-crop-height="option.autoCropHeight" :center-box="option.centerBox"
                            @real-time="realTime" :high="option.high" @img-load="imgLoad" mode="cover" :max-img-size="option.max" 
                            @crop-moving="cropMoving"></vue-cropper>

                            <div><img id='image-to-crop-SM2' /></div>

                            <v-spacer></v-spacer>
                            <v-btn width="100" id="crop-btn-SM2" class="primary white--text mt-4 btn-sm" @click="convertToImage()">{{$t("res_ButtonText_Crop")}}</v-btn>
                            <v-btn width="100" id="done-btn-SM2" class="primary white--text mt-4 btn-sm" @click="finish2()">{{$t("res_ButtonText_Done")}}</v-btn>              
                            <v-btn width="100" id="clear-btn-SM2" class="primary white--text mt-4 ml-4 mr-4 btn-sm" @click="resetCanvas()">{{$t("res_ButtonText_Clear")}}</v-btn> 
                        </v-col>
                    </v-row>
                    <v-row class="my-3 ml-3">
                        <v-checkbox v-model="editSignature.isDefault" color="#00ae8d" :label='$t("res_Label_IsDefault")'></v-checkbox>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="white" width="100" class="black--text" @click="EditSignatureDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                    <v-btn width="100" class="primary white--text" @click="editUserSignature()">{{$t("res_ButtonText_Submit")}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

         <v-dialog v-model="resizeSignatureDialog" width="75%" height="50%">
            <v-card>
                <v-card-title>
                    {{$t('res_Label_ResizeSignature')}} 
                </v-card-title>
                <v-card-text class="pb-0" v-if="!showResizeSignatureSkeleton">
                    <v-row>
                        <v-col cols="12" class="mt-4"> 
                            <label>{{$t('res_Label_MaintainAspectRatio')}} </label>
                            <v-checkbox v-model="resizeSignature.maintainAspectRatio" class="pt-2"></v-checkbox>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                     <label>{{$t('res_Label_Width')}} %</label>
                            <v-text-field 
                            max="100" 
                            oninput="if (Number(this.value) > Number(this.max)) this.value = this.max;"
                            solo type="number" @input="updateResizeSignatureHeight"  v-model="resizeSignature.width"></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                         <label>{{$t('res_Label_Height')}} %</label>
                            <v-text-field 
                            max="100" 
                            oninput="if (Number(this.value) > Number(this.max)) this.value = this.max;" solo type="number" @input="updateResizeSignatureWidth" v-model="resizeSignature.height"></v-text-field>
                        </v-col>
                    </v-row> 
                    <v-row class="p-0 m-1">
                        <v-col
                            class="text-center m-auto"
                            style="width: 100%; overflow: auto;"
                        >
                            <img
                            class="border rounded shadow-sm"
                            :style="{
                                width: resizeSignature.width/10 + 'vw',
                                height: resizeSignature.height/10 + 'vw'
                            }"
                            style="object-fit: contain; max-width: 100%;"
                            ref="image"
                            :src="resizeSignature.signature"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>

				<v-card-text class="pb-0" v-if="showResizeSignatureSkeleton">
                    <v-row>
                        <v-col cols="12" class="mt-4">
                            <label>{{$t('res_Label_MaintainAspectRatio')}} </label>
                            <v-checkbox v-model="resizeSignature.maintainAspectRatio" class="pt-2"></v-checkbox>
                        </v-col> 
                        <v-col cols="6" class="pt-0 ResizeElements">
                            <label>{{$t('res_Label_Width')}}</label>
                           <v-skeleton-loader  type="text"></v-skeleton-loader>
                        </v-col>
                        <v-col cols="6" class="pt-0 ResizeElements"> 
							<label>{{$t('res_Label_Height')}}</label>
                            <v-skeleton-loader  type="text"></v-skeleton-loader>
                        </v-col>
                    </v-row> 
                     <v-row class="p-0 m-1">
                        <v-col class="text-center m-auto ResizeImage" style="max-width: 1100px;max-height: 315px;overflow: auto;border-radius: 17px;">
                            <v-skeleton-loader  type="text"></v-skeleton-loader>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="mt-4">
                    <v-spacer></v-spacer>
                    <v-btn color="white" width="100" class="black--text" @click="resizeSignatureDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                    <v-btn width="100" class="primary white--text" @click="updateUserSignatureImageSize()">{{$t("res_ButtonText_Submit")}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="setPinCodeDialog" content-class="small-dialog" width="350" persistent>
            <v-card>
                <v-card-title>
                    {{ $t("res_DialogTitle_SetPinCode") }}
                </v-card-title>
                <div class="card-body">
                    <v-row class="mt-2">
                        <v-col class="col-md-12">
                            <label class="mb-2">{{ $t("res_Label_SetNewPinCode") }}<span style="color: red !important;"> *</span></label>
                            <v-text-field label="" solo :type="pincode.showNew ? 'text' : 'password'" v-model="pincode.setNewPin"
                                :append-icon="pincode.showNew ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="pincode.showNew = !pincode.showNew" autocomplete="new-password"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col class="col-md-12">
                            <label class="mb-2">{{ $t("res_Label_ConfirmNewPinCode") }}<span style="color: red !important;"> *</span></label>
                            <v-text-field label="" solo :type="pincode.showConfirm ? 'text' : 'password'" v-model="pincode.confirmNewPin"
                                :append-icon="pincode.showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="pincode.showConfirm = !pincode.showConfirm" autocomplete="new-password"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col class="col-md-12">
                            <label style="color: red !important;">{{ $t("res_Label_PincodeRefelctionAlert") }}</label>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" style="min-width: 100px !important;" @click="setPinCodeDialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn class="primary" style="min-width: 100px !important;" :loading="isSubmitting" :disabled="isSubmitting" @click="setSignaturePinCode()">{{ $t("res_ButtonText_Save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
   
<script>
    import axios from 'axios';
    import router from '@/router/index.js'
    import constants from '@/assets/js/constants'
    import MultiSelect from 'vue-multiselect'
    import * as utils from '@/assets/js/common.js'

    export default {
        name: 'UserSignatureManager',
        components: { MultiSelect },
        props: {
            userid: { type: Number, default: 0 },
            dialogModelShow: { type: Boolean, default: false },
            isAdmin: { type: Boolean, default: false }
        },
        data: function () {
            return {	
                isSubmitting: false,
                enableUserMultipleSignatures: constants.enableUserMultipleSignatures, 
                fetchedStructuresUserId: 0,
                userProfession: null,
                userProfessions: [{id:0 , text: ''}],
                imageUploaded:"",
                radioDraw: true,
                radioUpload: true,
                signatureWidth: 0,
			    signatureHeight: 0, 
			    showResizeSignatureSkeleton: true,
                userHavePinCode: false,      
                edit_image: '',
                showTempCanvas: true,
                signature_method: '1',
                current_action: 'new',
                optionsPad: {
                    dotSize: (0.5 + 2.5) / 2,
                    minWidth: 0.5,
                    maxWidth: 2.5,
                    throttle: 16,
                    minDistance: 5,
                    backgroundColor: 'rgba(0,0,0,0)',
                    penColor: 'black',
                    velocityFilterWeight: 0.7,
                    onBegin: () => 
                    {
                        if (this.$refs.signaturePad)
                            this.$refs.signaturePad.resizeCanvas()
                    },
                    onEnd: () => {}
                },
                model: false,
                modelSrc: '',
                crap: false,
                previews: {},
                imageFile: null,
                lists: [{ img: '' }],
                option: {
                    img: '',
                    size: 1,
                    full: false,
                    outputType: 'png',
                    canMove: true,
                    fixedBox: false,
                    original: false,
                    canMoveBox: true,
                    autoCrop: true,
                    autoCropWidth: 750,
                    autoCropHeight: 340,
                    centerBox: true,
                    high: true,
                    max: 99999
                },
                show: true,
                fixed: false,
                fixedNumber: [16, 9],
                loading: false,
                search_query: '',
                companyId: null,
                user_items: [],
                company_items: [],
                userId: 0,
                manageApplicationRoleDialog: false,
                options: ['list', 'of', 'options'],
                headers: [
                    { text: this.$t("res_GridHeaders_Name"), value: 'name' },
                    { text: this.$t("res_GridHeaders_NameAr"), value: 'nameAr' },
                    { text: this.$t("res_GridHeaders_Email"), value: 'email' },
                    { text: this.$t("res_GridHeaders_Structure"), value: 'parentName' },
                    { text: '', value: 'actions', sortable: false, width: '190px' },
                ],
                changePinCodeDialog: false,
                setPinCodeDialog: false,
                pincode: { setNewPin: "", confirmNewPin: "", showNew: false, showConfirm: false },
                changeUserPasswordDialog: false,
                showAddSignatureDialog: false,
                EditSignatureDialog: false,
                manageUserSignaturesDialog: false,
                signatureheaders: [
                    { text: 'Id', value: 'id', sortable: false, align: ' d-none' },
                    { text: this.$t("res_GridHeaders_Image"), value: 'thumbnail', sortable: false, width: '20%' },
                    { text: this.$t("res_GridHeaders_SignatureName"), value: 'name', sortable: false, width: '20%' },
                    { text: this.$t("res_Label_SignerName"), value: 'signerName', sortable: false, width: '15%'},
                    { text: this.$t("res_Label_SignerNameAr"), value: 'signerNameAr', sortable: false, width: '15%'},
                    { text: this.$t("res_Label_SignerPosition"), value: 'signerPosition', sortable: false, width: '15%'},
                    { text: this.$t("res_Label_SignerPositionAr"), value: 'signerPositionAr', sortable: false, width: '15%'},
                    { text: this.$t("res_GridHeaders_DefaultSignature"), value: 'isDefault', sortable: false, width: '10%'},
                    { text: '', value: '', sortable: false, width: '40%' },
                ],
                userSignature: {
                    selectedSignatures: [],
                    signatureName: '',
                    signatureFile: {},
                    isDefault: false,
                    uploadDocument: [ value => !!value || 'Please upload signature' ],
                    signerName:'',
                    signerNameAr: '',
                    signerPosition:'',
                    signerPositionAr: ''
                },
                editSignature: {
                    Id: 0,
                    signatureName: '',
                    signatureFile: {},
                    isDefault: false,
                    uploadDocument: [ value => !!value || 'Please upload signature' ],
                    signerName:'',
                    signerNameAr: '',
                    signerPosition:'',
                    signerPositionAr: ''
                },
                resizeSignature: { id: 0, width: 0, height: 0, signature: '', maintainAspectRatio: true, originalWidth: 0, originalHeight: 0 },
                resizeSignatureDialog: false,
                aspectRatioSynchronizing: false,
                client_version_Id: constants.client_version_Id,
                tempSignature : null,
                maxLengthForSignatureName: 30,
                maxFileSizeLimit: 3 * 1024 * 1024,
                forbiddenWords: ['بالانابة', 'عن', '/ عن', '/ ع', '/ع', '/عن', 'behalf']
            }
        },
        watch: {
            'userSignature.isDefault'(newVal, oldVal){
                if (newVal != oldVal && newVal == true)
                {
                    var user = JSON.parse(sessionStorage.getItem("user"))
                }
                else
                {

                }
            },
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
                        this.getUserSinatures()
                }
            },
            signature_method(newValue, oldValue)
            {
                if(newValue == '2')
                {
                    this.imageUploaded = "";
                    this.userSignature.signatureFile = {}
                    const input = this.$refs.signatureInput?.$el?.querySelector('input');
                    if (input) input.value = null;
                }
                else
                {
                    var imgtocrop1=document.getElementById('image-to-crop-SM');
                    var signatureModel=document.getElementById('signatureModel');
                    var cropperSM=document.getElementById('cropper-SM');
                    const cropBtn = document.getElementById('crop-btn-SM')
                    const clearBtn =document.getElementById('clear-btn-SM')
                    const doneBtn = document.getElementById('done-btn-SM');
                    imgtocrop1.style.display='none';
                    signatureModel.style.display='block';
                    this.userSignature.signatureFile={};

                    document.getElementById('input-file').value = null;
                    if(cropperSM&&cropperSM.style.display=='block'){
                        cropperSM.style.display='none';
                    }
                    if(cropBtn&&cropBtn.style.display=='none'){
                        cropBtn.style.display='inline';
                    }
                    if(clearBtn&&clearBtn.style.display=='none'){
                        clearBtn.style.display='inline';
                    }
                    if(doneBtn&&doneBtn.style.display=='block'){
                        doneBtn.style.display='none';
                    }
                    this.resetCanvas();                    
                }

                if (newValue=='2' && this.current_action=='edit' )
                {
                    window.showLoading();
                    setTimeout(()=>
                    {
                        this.$refs.signaturePad.resizeCanvas();
                        this.getSignature();
                        this.$refs.signaturePad.fromDataURL(this.canvasBase64)
                        window.hideLoading()
                    }, "1000")
                }
            },
            EditSignatureDialog(newValue,oldValue)
            {
                if (newValue == false)
                {
                    var imgtocrop2=document.getElementById('image-to-crop-SM2');
                    var signatureModel2=document.getElementById('signatureModel2');
                    var cropperSM=document.getElementById('cropper-SM2');
                    const cropBtn = document.getElementById('crop-btn-SM2')
                    const clearBtn =document.getElementById('clear-btn-SM2')
                    const doneBtn = document.getElementById('done-btn-SM2'); 
                    imgtocrop2.style.display='none';
                    signatureModel2.style.display='block';
                    this.userSignature.signatureFile={};
                    this.userSignature.signatureName="";
                    this.userSignature.signerName="";
                    this.userSignature.signerNameAr="";
                    this.userSignature.signerPosition="";
                    this.userSignature.signerPositionAr="";
                    if(cropperSM&&cropperSM.style.display=='block'){
                        cropperSM.style.display='none';
                    }
                    if(cropBtn&&cropBtn.style.display=='none'){
                        cropBtn.style.display='inline';
                    }
                    if(clearBtn&&clearBtn.style.display=='none'){
                        clearBtn.style.display='inline';
                    }
                    if(doneBtn&&doneBtn.style.display=='block'){
                        doneBtn.style.display='none';
                    }
                    this.resetCanvas();
                    this.signature_method = '1';
                }
            },
            showAddSignatureDialog(newValue,oldValue)
            {                
                if (newValue == false)
                {
                    var imgtocrop1=document.getElementById('image-to-crop-SM');
                    var signatureModel=document.getElementById('signatureModel');
                    var cropperSM=document.getElementById('cropper-SM');
                    const cropBtn = document.getElementById('crop-btn-SM')
                    const clearBtn =document.getElementById('clear-btn-SM')
                    const doneBtn = document.getElementById('done-btn-SM');
                    imgtocrop1.style.display='none';
                    signatureModel.style.display='block';
                    this.userSignature.signatureFile={};
                    this.userSignature.signatureName="";
                    document.getElementById('input-file').value = null;
                    if(cropperSM&&cropperSM.style.display=='block'){
                        cropperSM.style.display='none';
                    }
                    if(cropBtn&&cropBtn.style.display=='none'){
                        cropBtn.style.display='inline';
                    }
                    if(clearBtn&&clearBtn.style.display=='none'){
                        clearBtn.style.display='inline';
                    }
                    if(doneBtn&&doneBtn.style.display=='block'){
                        doneBtn.style.display='none';
                    }
                    this.resetCanvas();
                    this.signature_method = '1';
                }
            }, 
        },
        methods:
        {   
            closeAddEditDialog(){
                
                if(this.fetchedStructuresUserId > 0)
                {
                    this.userProfessions = this.userProfessions.filter(s=> s.id != this.fetchedStructuresUserId);
                    if(this.userProfessions?.length == 1){this.userProfession = this.userProfessions[0];}
                    this.fetchedStructuresUserId = 0; 
                }
                this.showAddSignatureDialog = false;   
                this.imageUploaded = "";
                this.canvasBase64 = "";    
                   
            },
            async GetUserProfessions() { 
                try { 
                    const response =
                        await axios.get(`${constants.baseApiUrl}Admin/GetUserProfessions?lang=${localStorage.getItem('lang')}`);
                    if (response.data) { 
                            this.userProfessions = response.data;
                            if(this.userProfessions.length == 1)
                            {
                                this.userProfession = this.userProfessions[0];
                            }
                    }
                } catch (error) {
                    console.error(error);
                }
            },
            async updateUserSignatureImageSize() 
            {
                let isFormValid = this.resizeSignature.height > 0 && this.resizeSignature.width > 0 && this.resizeSignature.id > 0;
                if (isFormValid == false) 
                {
                    window.showAlert(this.$t("res_Msg_NotAllowedNegativeNumbere"), "warning");
                    return;
                }

                try 
                { 
                    const response =
                        await axios.post(`${constants.baseApiUrl}Admin/UpdateUserSignatureImageSize?signatureId=${this.resizeSignature.id}&width=${parseInt(this.resizeSignature.width)}&height=${parseInt(this.resizeSignature.height)}`);
                    if (response.data.success == true) 
                    {
                        window.showAlert(this.$t("res_Msgs_SuccessfulSave"), "success");
                        this.resizeSignatureDialog = false; 
                        this.getUserSinatures();
                    }
                } 
                catch (error) 
                {
                    console.error(error);
                }
		    },
           	async fetchOriginalWidth_Height(file) {
                return new Promise((resolve, reject) => {
                    if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const img = new Image();
                        img.src = e.target.result;
                        img.onload = () => {
                        const width = img.width;
                        const height = img.height;
                        resolve({ "width":width,"height":height });
                        };
                    };
                    reader.readAsDataURL(file);
                    } else {
                    reject("File not provided");
                    }
                });
			},
            close()
            {
                this.$emit('closeDialog')
            },
            isFileTypeValid() {
                const file = this.userSignature.signatureFile;
                return file && file.type.startsWith('image/');
            },
            async removeBackgroundColorOnAdd(file)
            {
                const selectedFile = Array.isArray(file) ? file[0] : file;

                if (selectedFile && selectedFile.size > this.maxFileSizeLimit) {
                    this.$nextTick(() => {
                        this.userSignature.signatureFile = {};
                    });
                    window.showAlert(this.$t("res_Msgs_SignatureSizeExceeded"), "warning");
                    return;
                }

                const isFileTypeValid = this.isFileTypeValid();
                if(isFileTypeValid == false)
                {
                    window.showAlert(this.$t("res_Msgs_FileMustBeImage"), "warning");
                    this.userSignature.signatureFile = {};
                    return;
                }
                let MainImage = await this.fetchOriginalWidth_Height(this.userSignature.signatureFile); 
                if (this.userSignature.signatureFile && this.userSignature.signatureFile !=null && this.userSignature.signatureFile!= undefined)
                {
                    this.readFile(this.userSignature.signatureFile, (fileBytes) => {
                        window.showLoading();
                        var array = fileBytes,
                        imgData = fileBytes;
                        const canvas=document.getElementById('signatureCanvas');
                        canvas.width = MainImage.width;
				        canvas.height = MainImage.height;
                        //draw image
                        var ctx = canvas.getContext("2d");
                        var uInt8Array = imgData;
                        var i = uInt8Array.length;
                        var binaryString = [i];
                        while (i--) {
                            binaryString[i] = String.fromCharCode(uInt8Array[i]);
                        }
                        var data = binaryString.join('');
                        var base64 = window.btoa(data);
                        var img = new Image();
                        img.src = "data:image/png;base64," + base64;
                        this.imageUploaded = "data:image/png;base64," + base64;
                        img.onload =  () => 
                        {
                            ctx.drawImage(img,0, 0, canvas.width, canvas.height);
                            var imgd = ctx.getImageData(0, 0, canvas.width, canvas.height),
                                pix = imgd.data,
                            newColor = {r:0,g:0,b:0, a:0};
                            for (var i = 0, n = pix.length; i <n; i += 4) {
                                var r = pix[i],
                                        g = pix[i+1],
                                        b = pix[i+2];
                                    if(r == 255&& g == 255 && b == 255){ 
                                        // Change the white to the new color.
                                        pix[i] = newColor.r;
                                        pix[i+1] = newColor.g;
                                        pix[i+2] = newColor.b;
                                        pix[i+3] = newColor.a;
                                    }
                            }
                            ctx.putImageData(imgd, 0, 0);
                            const image = new Image();
                            image.src = canvas.toDataURL();
                            this.imageUploaded = canvas.toDataURL();
                            this.ConvertClick(image.src);
                            canvas.style.height="0px";
                            window.hideLoading()
                        }; 
                    })
                }
            },
            removeImageWhiteBg()
            {
                const canvasDiv =  document.getElementById('signatureModel')
                const canvas = canvasDiv.getElementsByTagName('canvas')[0];
                const ctx = canvas.getContext('2d');
                var imgd = ctx.getImageData(0, 0, canvas.width, canvas.height), pix = imgd.data, newColor = {r:0,g:0,b:0, a:0};
                for (var i = 0, n = pix.length; i <n; i += 4) 
                {
                    var r = pix[i], g = pix[i+1], b = pix[i+2];
                    if(r == 255&& g == 255 && b == 255)
                    { 
                        // Change the white to the new color.
                        pix[i] = newColor.r;
                        pix[i+1] = newColor.g;
                        pix[i+2] = newColor.b;
                        pix[i+3] = newColor.a;
                    }
                }
                ctx.putImageData(imgd, 0, 0);
            },
            getSignature()
            {
                let self = this;
                self.$refs.signaturePad.fromDataURL(this.canvasBase64);
                this.$refs.signaturePad.fromDataURL(this.canvasBase64);

                const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
                    const byteCharacters = atob(b64Data);
                    const byteArrays = [];
                    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                        const slice = byteCharacters.slice(offset, offset + sliceSize);
                        const byteNumbers = new Array(slice.length);
                        for (let i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                    }
                    const blob = new Blob(byteArrays, {type: contentType});
                    return blob;
                }
                const contentType = 'image/png';
                const b64Data = this.canvasBase64.replace('data:image/png;base64,','');
                const blob = b64toBlob(b64Data, contentType);
                const blobUrl = URL.createObjectURL(blob);
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => 
                {
                    self.$refs.signaturePad.fromDataURL(reader.result);
                    this.$refs.signaturePad.fromDataURL(reader.result);
                }
            },
            //crop methods
            changeImg() {
                this.option.img = this.lists[~~(Math.random() * this.lists.length)].img
            },
            startCrop() {
                // start
                this.crap = true
                this.$refs.cropperSM.startCrop()
            },
            stopCrop() {
                //  stop
                this.crap = false
                this.$refs.cropperSM.stopCrop()
            },
            clearCrop() {
                // clear
                this.$refs.cropperSM.clearCrop()
            },
            refreshCrop() {
                // clear
                this.$refs.cropperSM.refresh()
            },
            changeScale(num) {
                num = num || 1
                this.$refs.cropperSM.changeScale(num)
            },
            rotateLeft() {
                this.$refs.cropperSM.rotateLeft()
            },
            rotateRight() {
                this.$refs.cropperSM.rotateRight()
            },
            finish(type) {
            
                if (type === 'blob') {
                this.$refs.cropperSM.getCropBlob((data) => {
                    var img = window.URL.createObjectURL(data)
                    this.model = true
                    this.modelSrc = img
                })
                } 
                else 
                {
                    this.$refs.cropperSM.getCropData((data) => {
                        this.model = true
                        this.modelSrc = data
                    })
                }
            },
            realTime(data) 
            {
                this.previews = data;
            },
            finish2(type) 
            {
                this.$refs.cropperSM.getCropData((data) => {
                    this.model = true
                    this.modelSrc = data;
                    var itc=document.getElementById('image-to-crop-SM')
                    itc.src=data
                    itc.style.display='block'
                    var cr=document.getElementById('cropper-SM')
                    cr.style.display='none'
                    var doneBtn= document.getElementById('done-btn-SM')
                    doneBtn.style.display='none'
                    this.ConvertClick(data);
                })
            },
            finish3(type) {
                this.$refs.cropperSM3.getCropData((data) => {
                    this.model = true
                    this.modelSrc = data
                })
            },
            down(type) {
                // event.preventDefault()
                var aLink = document.createElement('a')
                aLink.download = 'demo'
                if (type === 'blob') {
                    this.$refs.cropperSM.getCropBlob((data) => {
                        this.downImg = window.URL.createObjectURL(data)
                        aLink.href = window.URL.createObjectURL(data)
                        aLink.click()
                    })
                } else {
                    this.$refs.cropperSM.getCropData((data) => {
                        this.downImg = data
                        aLink.href = data
                        aLink.click()
                    })
                }
            },
            uploadImg(e, num) 
            {
                var file = e.target.files[0]
                if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) 
                {
                    return false
                }

                var reader = new FileReader()
                reader.onload = (e) => {
                    let data
                    if (typeof e.target.result === 'object') {
                        data = window.URL.createObjectURL(new Blob([e.target.result]))
                    } 
                    else 
                    {
                        data = e.target.result
                    }
                    if (num === 1) {
                        this.option.img = data
                    } else if (num === 2) {
                        this.example2.img = data
                    }
                }
                reader.readAsArrayBuffer(file)
            },
            imgLoad(msg) 
            {
            },
            cropMoving(data) 
            {
            },
            //canvas signature methods
            convertToImage2()
            {
                const canvasDiv = document.getElementById('signatureModel')
                const canvas = canvasDiv.getElementsByTagName('canvas')[0];
                const context = canvas.getContext('2d');
                // Create an image element
                const image = new Image();
                // Assign the canvas content as the source of the image
                image.src = canvas.toDataURL();
                this.option.img = image.src;
                this.ConvertClick(image.src);
            },
            convertToImage() {
                const { isEmpty } = this.$refs.signaturePad.saveSignature();
                if(isEmpty)
                {
                    window.showAlert(this.$t("res_Msgs_SignatureRequired"), "warning");
                    //this.$refs.signaturePad.clear();
                    return;
                }
                this.removeImageWhiteBg();
                // Get the canvas element
                const canvasDiv = document.getElementById('signatureModel')
                const canvas = canvasDiv.getElementsByTagName('canvas')[0];
                const context = canvas.getContext('2d');
                // Create an image element
                const image = new Image();
                // Assign the canvas content as the source of the image
                image.src = canvas.toDataURL();
                const imageObject = document.getElementById('image-to-crop-SM')
                const doneBtn = document.getElementById('done-btn-SM')
                const cropBtn = document.getElementById('crop-btn-SM')
                const clearBtn =document.getElementById('clear-btn-SM')
                const cropper =document.getElementById('cropper-SM')
                cropper.style.display = "block";
                cropBtn.style.display = "none";
                canvasDiv.style.display = "none";
                clearBtn.style.display = "none";   
                doneBtn.style.display = "block";
                imageObject.src = '';
                this.option.img = image.src;
                this.ConvertClick(image.src);
            },
            undo() {
                this.$refs.signaturePad.fromData([]);
            },
            save() {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            },
            change() 
            {
                this.options = { penColor: "#00f" };
            },
            resume() 
            {
                this.options = { penColor: "#c0f" };
            },
            backToAdminPage()
            {
                router.push({ name: 'admin' })
            },
            clearFields() 
            {
                this.search_query = ''
                this.companyId = {}
            },
            changeUserActivationStatus(_userId) 
            {
                window.showLoading()
                axios.get(constants.baseApiUrl + "Admin/ToggleUserActivationStatus?userId=" + _userId)
                    .then((res) => 
                    {
                        if(res != null && res != undefined)
                        this.user_items.find(x=>x.userId == _userId).active =res.data
                    })
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading());
            },
            manageUserSignatures(id) 
            {
                this.userId = id;
            },
            getUserSinatures() 
            {
                this.userSignature.selectedSignatures = []
                var user = JSON.parse(sessionStorage.getItem("user"));
                this.userId = this.userid;

                axios.get(constants.baseApiUrl + "Admin/DoesUserHavePinCode?userId=" + this.userId)
                    .then((res) => {
                        this.userHavePinCode = res.data
                    })
                    .catch((err) => { console.warn(err); });
                window.showLoading();
                axios.get(constants.baseApiUrl + 'Admin/GetUserSignatures?userId=' + this.userId)
                    .then(response => {
                        if (response.data != null) {
                            response.data.forEach((item) => {
                                var signatureBody = {
                                    id: item.id,
                                    name: item.name,
                                    isDefault: localStorage.getItem('lang') == 'en'? item.isDefault: (item.isDefault ? 'نعم':'لا' ) ,
                                    thumbnail: "data:image/png;base64," + item.thumbnail,
                                    isUploaded: item.isUploaded,
                                    signerName: item.signerName,
                                    signerPosition: item.signerPosition,
                                    signerNameAr: item.signerNameAr,
                                    signerPositionAr: item.signerPositionAr

                                }
                                this.userSignature.selectedSignatures.push(signatureBody)
                            });
                        }
                        this.manageUserSignaturesDialog = true
                    })
                    .catch((err) => { console.warn(err) })
                    .finally(() => window.hideLoading());
            },
            
            resetCanvas () 
            {
                this.undo();
            },
            openAddSignatureDialog() {
                this.getSelectedUserInfo(this.userid, )
                this.radioDraw = true
                this.radioUpload = true
                this.current_action='new';
                this.imageUploaded = "";
                this.userSignature.signatureFile = {}

                this.showAddSignatureDialog = true;
            },
            openSetPinCodeDialog() {
                this.pincode.setNewPin = "";
                this.pincode.confirmNewPin = "";
                this.pincode.showNew = false;
                this.pincode.showConfirm = false;
                this.setPinCodeDialog = true;
            },
            setSignaturePinCode() {
                if (this.isSubmitting) return; // Prevent double click

                if (!this.pincode.setNewPin.trim() || !this.pincode.confirmNewPin.trim()) {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
                    return;
                }
                if (this.pincode.setNewPin !== this.pincode.confirmNewPin) {
                    window.showAlert(this.$t("res_Msgs_PinCodeNotMatching"), "warning");
                    return;
                }

                this.isSubmitting = true;
                const afterSubmit = () => { this.isSubmitting = false; };
                const onSuccess = () => {
                    this.userHavePinCode = true;
                    this.setPinCodeDialog = false;
                    this.pincode.setNewPin = "";
                    this.pincode.confirmNewPin = "";
                    window.showAlert(this.$t("res_Msgs_SignaturePinCodeUpdation"), "success");
                };

                if (this.isAdmin) {
                    // Admin sets the pin code for the managed user
                    axios.post(constants.baseApiUrl + 'Admin/ChangeUserPinCode?userId=' + this.userId + '&newPinCode=' + encodeURIComponent(this.pincode.confirmNewPin))
                        .then(response => {
                            if (response.data === true)
                                onSuccess();
                            else
                                window.showAlert(this.$t("res_general_error"), "error");
                            afterSubmit();
                        })
                        .catch(err => { console.warn(err); afterSubmit(); });
                }
                else {
                    // User sets his own signature pin code
                    var body = { NewSignaturePin: this.pincode.confirmNewPin };
                    axios.post(constants.baseApiUrl + 'User/UpdateUserSignaturePin', body, { headers: constants.headers })
                        .then(response => {
                            if (response.data != null && response.data > 0)
                                onSuccess();
                            else
                                window.showAlert(this.$t("res_general_error"), "error");
                            afterSubmit();
                        })
                        .catch(err => { console.warn(err); afterSubmit(); });
                }
            },
            getSelectedUserInfo(userId) {
                axios.get(constants.baseApiUrl + 'Admin/GetSelectedUserInfo?userId=' + userId)
                    .then(response => {
                        if (response.data != null) {
                            this.userSignature.signerName = response.data.signerName;
                            this.userSignature.signerNameAr = response.data.signerNameAr;
                            this.userSignature.signerPosition = response.data.signerPosition;
                            this.userSignature.signerPositionAr = response.data.signerPositionAr;
                        }
                    })
                    .catch(err => {
                        console.warn(err);
                        window.showAlert(err, 'error');
                    });
            },
            dataURLtoFile(dataurl, filename) 
            {
                var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, { type: mime });
            },
            ConvertClick(base64url) {
                var extension=new Date().getTime();
                var file = this.dataURLtoFile(base64url, String("signature"+extension+".png"));
                let container = new DataTransfer();
                container.items.add(file);
                var input=document.createElement('input');
                input.type="file";
                input.id='input-file'
                input.files=container.files;
                var newfile =input.files[0];
           
                this.userSignature.signatureFile=newfile;
           
                this.imageFile=this.base64ToArrayBuffer(base64url.split('data:image/png;base64,')[1]);
            },
            base64ToArrayBuffer(base64) {
                var binaryString = atob(base64);
                var bytes = new Uint8Array(binaryString.length);
                for (var i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                return bytes.buffer;
            },
            addUserSignature() 
            {
                if (this.isSubmitting) return; // Prevent double click

                if (!this.userSignature.signatureFile.size || !this.userSignature.signatureName.trim()  ) {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
                    return;
                }

                if (this.isAdmin && (!this.userSignature.signatureFile.size || !this.userSignature.signatureName.trim() || !this.userSignature.signerName.trim() || !this.userSignature.signerNameAr.trim() || !this.userSignature.signerPosition.trim() || !this.userSignature.signerPositionAr.trim())) {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
                    return;
                }

                if(this.userSignature.signatureName.trim().length > this.maxLengthForSignatureName)
                {
                    window.showAlert(this.$t("res_Msgs_SignatureNameMaxLength") + this.maxLengthForSignatureName + " " + this.$t("res_Label_Characters"), "warning");
                    return;
                }

                const doesADefaultSignatureExist = this.userSignature.selectedSignatures.some(x => x.isDefault == true || x.isDefault == "نعم");
                if(this.userSignature.isDefault == false && doesADefaultSignatureExist == false)
                {
                    window.showAlert(this.$t("res_Msgs_DefaultSignatureRequired"), "warning");
                    return;
                }

                var fieldsToCheck = [
                    this.userSignature.signatureName,
                    this.userSignature.signerName,
                    this.userSignature.signerNameAr,
                    this.userSignature.signerPosition,
                    this.userSignature.signerPositionAr
                ];
                for (const field of fieldsToCheck) {
                    if (!field) continue;
                    const fieldLower = field.toLowerCase();
                    for (const word of this.forbiddenWords) {
                        if (fieldLower.includes(word.toLowerCase())) {
                            window.showAlert(this.$t("res_Msgs_SignatureForbiddenWord") + ' "' + word + '"', 'warning');
                            return;
                        }
                    }
                }

                this.isSubmitting = true;

                const afterSubmit = () => { this.isSubmitting = false; };

                if (this.signature_method=='2')
                {
                    this.readFile(this.userSignature.signatureFile, (fileBytes) => {
                        var signatureBody = {
                            SignatureUserId: this.userId,
                            SignaturePin: this.userSignature.signaturePin,
                            SignatureBytes: fileBytes,
                            SignatureName: this.userSignature.signatureName,
                            SignerNameAr : this.userSignature.signerNameAr,
                            SignerName  : this.userSignature.signerName,
                            SignerPosition: this.userSignature.signerPosition,
                            SignerPositionAr: this.userSignature.signerPositionAr,
                            IsDefault: this.userSignature.isDefault,
                            IsUploaded: false,
                            StructuresUserId:  this.userProfession == null ? 0 : this.userProfession.id
                        }

                    axios.post(constants.baseApiUrl + 'Admin/AddUserSignature', signatureBody)
                        .then(response => {
                            if (response.data) {
                                this.getUserSinatures()
                                this.showAddSignatureDialog = false
                                this.userSignature.signatureFile = {}
                                this.userSignature.signatureName = ''
                                this.userSignature.isDefault = false
                                this.userSignature.signerName = ''
                                this.userSignature.signerPosition = ''
                                this.userSignature.signerNameAr = ''
                                this.userSignature.signerPositionAr = ''
                                this.GetUserProfessions(); 
                                window.showAlert(this.$t("res_Msgs_SignatureAddedSuccess"), 'success')
                            }
                            else
                                window.showAlert(this.$t("res_general_error"), 'error')

                            afterSubmit();
                        })
                        .catch(err => {
                            console.warn(err);
                            afterSubmit(); // <-- this will run after logging the error
                        });
                    });
                }
                else
                {
                    this.readFile(this.userSignature.signatureFile, (fileBytes) => {
                        var signatureBody = {
                            SignatureUserId: this.userId,
                            SignaturePin: this.userSignature.signaturePin,
                            SignatureBytes: fileBytes,
                            SignatureName: this.userSignature.signatureName,
                            SignerName  : this.userSignature.signerName,
                            SignerNameAr  : this.userSignature.signerNameAr,
                            SignerPosition: this.userSignature.signerPosition,
                            SignerPositionAr: this.userSignature.signerPositionAr,
                            IsDefault: this.userSignature.isDefault,
                            IsUploaded: true,
                            StructuresUserId: this.userProfession == null ? 0 : this.userProfession.id
                        }

                        axios.post(constants.baseApiUrl + 'Admin/AddUserSignature', signatureBody)
                            .then(response => {
                                if (response.data) {
                                    this.getUserSinatures()
                                    this.showAddSignatureDialog = false
                                    this.userSignature.signatureFile = {}
                                    this.userSignature.signatureName = ''
                                    this.userSignature.isDefault = false
                                    this.userSignature.signerName=''
                                    this.userSignature.signerPosition=''
                                    this.userSignature.signerNameAr=''
                                    this.userSignature.signerPositionAr=''
                                    this.GetUserProfessions(); 
                                    window.showAlert(this.$t("res_Msgs_SignatureAddedSuccess"), 'success')
                                }
                                else
                                {
                                    window.showAlert(this.$t("res_Msgs_EmptyPin"), 'warning')    
                                }
                                afterSubmit();
                            })
                            .catch(err => {
                                console.warn(err);
                                afterSubmit(); // <-- this will run after logging the error
                            });
                    });
                }                
            },
            editUserSignature() 
            {
                if (this.isSubmitting) return; // Prevent double click

                if (!this.userSignature.signatureName.trim() || (this.signature_method=='2' && !this.userSignature.signatureFile.size)) 
				{
                    window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
                    return;
                }

                if (this.isAdmin && (!this.userSignature.signatureName.trim() || (this.signature_method=='2' && !this.userSignature.signatureFile.size) || !this.userSignature.signerName.trim() || !this.userSignature.signerPosition.trim())) {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
                    return;
                }
                
                if(this.userSignature.signatureName.trim().length > this.maxLengthForSignatureName)
                {
                    window.showAlert(this.$t("res_Msgs_SignatureNameMaxLength") + this.maxLengthForSignatureName + " " + this.$t("res_Label_Characters"), "warning");
                    return;
                }

                const doesADefaultSignatureExist = this.userSignature.selectedSignatures.some(x => x.id != this.editSignature.Id && (x.isDefault == true || x.isDefault == "نعم"));
                if(this.userSignature.isDefault == false && doesADefaultSignatureExist == false)
                {
                    window.showAlert(this.$t("res_Msgs_DefaultSignatureRequired"), "warning");
                    return;
                }

                this.isSubmitting = true;

                const afterSubmit = () => { this.isSubmitting = false; };

                if(this.userSignature.signatureFile.size){
                    this.readFile(this.userSignature.signatureFile, (fileBytes) => {
                        var signatureBody = {
                            Id:this.editSignature.Id,
                            SignatureUserId: this.userId,
                            SignaturePin: this.userSignature.signaturePin,
                            SignatureBytes: fileBytes,
                            SignatureName: this.userSignature.signatureName,
                            SignerName  : this.userSignature.signerName,
                            SignerPosition: this.userSignature.signerPosition,
                            SignerNameAr  : this.userSignature.signerNameAr,
                            SignerPositionAr: this.userSignature.signerPositionAr,
                            IsDefault: this.userSignature.isDefault,
                            StructuresUserId: this.userProfession == null ? 0 : this.userProfession.id,
                        }
                        axios.post(constants.baseApiUrl + 'Admin/EditUserSignature', signatureBody)
                            .then(response => {
                                if (response.data) {
                                    this.getUserSinatures()
                                    this.showAddSignatureDialog = false
                                    this.userSignature.signatureFile = {}
                                    this.userSignature.signatureName = ''
                                    this.userSignature.isDefault = false
                                    this.userSignature.signerName=''
                                    this.userSignature.signerPosition=''
                                     this.userSignature.signerNameAr=''
                                    this.userSignature.signerPositionAr=''
                                    this.GetUserProfessions(); 
                                    window.showAlert(this.$t("res_Msgs_SignatureEditedSuccess"), 'success')
                                }
                                else
                                {
                                    window.showAlert(this.$t("res_general_error"), 'error')    
                                }

                                afterSubmit();
                            })
                            .catch(err => {
                                console.warn(err);
                                afterSubmit(); // <-- this will run after logging the error
                            });
                    });
                }
                else{
                      var signatureBody = { 
                            Id:this.editSignature.Id,
                            SignatureUserId: this.userId,
                            SignaturePin: this.userSignature.signaturePin,
                            SignatureName: this.userSignature.signatureName,
                            SignerName  : this.userSignature.signerName,
                            SignerPosition: this.userSignature.signerPosition,
                            SignerNameAr  : this.userSignature.signerNameAr,
                            SignerPositionAr: this.userSignature.signerPositionAr,
                            IsDefault: this.userSignature.isDefault,
                            StructuresUserId: this.userProfession == null ? 0 : this.userProfession.id,
                        }
                        axios.post(constants.baseApiUrl + 'Admin/EditUserSignature', signatureBody)
                            .then(response => {
                                if (response.data) {
                                    this.getUserSinatures()
                                    this.showAddSignatureDialog = false
                                    this.userSignature.signatureFile = {}
                                    this.userSignature.signatureName = ''
                                    this.userSignature.isDefault = false
                                    this.userSignature.signerName=''
                                    this.userSignature.signerPosition=''
                                    this.userSignature.signerNameAr=''
                                    this.userSignature.signerPositionAr=''
                                    this.GetUserProfessions(); 
                                    window.showAlert(this.$t("res_Msgs_SignatureEditedSuccess"), 'success')
                                }
                                else
                                {
                                    window.showAlert(this.$t("res_general_error"), 'error')    
                                }

                                afterSubmit();
                            })
                            .catch(err => {
                                console.warn(err);
                                afterSubmit(); // <-- this will run after logging the error
                            });
                }
            },
            deleteUserSignature(signatureId) {
                window.showInformation(this.$t('res_Msg_Warning'), this.$t("res_Msgs_SignatureEnsureDelete"), () => {
                    const isDefaultSignature = this.userSignature.selectedSignatures.some(x => x.id == signatureId && x.isDefault == true);
                    if (isDefaultSignature) {
                        window.showAlert(this.$t("res_Msgs_DefaultSignatureCannotBeDeleted"), this.$t('res_Msg_Warning'));
                        return;
                    }
                    window.showLoading();
                    axios.get(constants.baseApiUrl + 'Admin/DeleteUserSignature?signatureId=' + signatureId)
                        .then(response => {
                            if (response.data != null) {
                                this.getUserSinatures()
                                this.userSignature.SignatureDeleteDialog = false
                                window.showAlert(this.$t("res_Msgs_SignatureDeletedSuccess"), this.$t('res_Msg_Success'))
                                this.GetUserProfessions(); 
                            }
                        })
                        .catch(err => console.warn(err))
                        .finally(() => {hideLoading()});
                }, () => { });
            },
            getUserSignature(signatureId) 
            {
                this.current_action='edit'
                const userSignatureObj=this.userSignature.selectedSignatures.filter((obj)=>{
                    return obj.id == signatureId;
                });

                axios.get(constants.baseApiUrl + `Admin/GetUserSignature?signatureId=${signatureId}&lang=${localStorage.getItem('lang')}`)
                    .then(response => {
                        if (response.data != null) 
                        {
                           console.log('response.data = ',response.data)
                            if(!response.data.isUploaded)
                            {
                                this.editSignature.Id = signatureId
                                if(response.data.structuresUserText)
                                { 
                                    this.fetchedStructuresUserId = response.data.structuresUserId;
                                    this.userProfessions.push({id : response.data.structuresUserId , text: response.data.structuresUserText});
                                    this.userProfession = {id : response.data.structuresUserId , text: response.data.structuresUserText};
                                } 
                                this.userSignature.signatureName = response.data.name
                                this.userSignature.signature = response.data.image
                                this.userSignature.isDefault = response.data.isDefault
                                this.userSignature.thumbnail = response.data.thumbnail
                                this.userSignature.signerName = response.data.signerName 
                                this.userSignature.signerPosition = response.data.signerPosition 
                                this.userSignature.signerNameAr = response.data.signerNameAr 
                                this.userSignature.signerPositionAr = response.data.signerPositionAr
                                this.edit_image="data:image/png;base64," + response.data.image;
                                this.canvasBase64="data:image/png;base64," + response.data.image;
                                this.showAddSignatureDialog=true;
                                this.current_action="edit";
                                this.tempSignature = {...this.userSignature};
                                this.signature_method = '2'
                                this.radioDraw = true
                                this.radioUpload = false
                            }
                            else
                            {
                                this.editSignature.Id = signatureId
                                this.userSignature.signatureName = response.data.name
                                this.userSignature.signature = response.data.image
                                this.userSignature.isDefault = response.data.isDefault
                                this.userSignature.thumbnail = response.data.thumbnail
                                this.userSignature.signerName = response.data.signerName 
                                this.userSignature.signerPosition = response.data.signerPosition 
                                this.userSignature.signerNameAr = response.data.signerNameAr
                                this.userSignature.signerPositionAr = response.data.signerPositionAr 
                                this.edit_image="data:image/png;base64," + response.data.image;
                                this.canvasBase64="data:image/png;base64," + response.data.image;
                                this.showAddSignatureDialog=true;
                                this.current_action="edit";
                                this.tempSignature = {...this.userSignature};
                                this.radioDraw = false
                                this.radioUpload = true
                                this.imageUploaded = "data:image/png;base64," + response.data.image;    
                                this.signature_method = null;
                                this.$nextTick(() => {
                                    this.signature_method = '1';
                                });
                            }
                        }
                    })
                    .catch(err => console.warn(err));  
            },
            async readFile(file, successHandler) 
            {
                var reader = new FileReader();
                var fileByteArray = [];
                reader.readAsArrayBuffer(file);
                reader.onloadend = function (evt) {
                    if (evt.target.readyState == FileReader.DONE) {
                        var arrayBuffer = evt.target.result,
                            array = new Uint8Array(arrayBuffer);
                        for (var i = 0; i < array.length; i++) {
                            fileByteArray.push(array[i]);
                        }
                        successHandler(fileByteArray);
                    }
                }
            },
            openResizeSignatureDialog(item) 
            {
                this.resizeSignatureDialog = true;
                    axios
                        .get(
                            constants.baseApiUrl +
                                "Admin/GetUserSignature?signatureId=" +
                                item.id
                        )
                        .then((response) => {
                            if (response.data != null) {
                                this.resizeSignature.signature =
                                    "data:image/png;base64," + response.data.image;
                                this.resizeSignature.id = item.id;  
                                this.showResizeSignatureSkeleton = false;
                            setTimeout(() => { 
                                    const img = new Image();
                                    img.src = this.$refs.image.src;
                                    img.onload = () => {
                                        this.resizeSignature.originalWidth = img.width;
                                        this.resizeSignature.originalHeight = img.height;
                                        this.resizeSignature.width = response.data.width > 400 ? 400 : response.data.width;
                                        this.resizeSignature.height = response.data.height > 400 ? 400 : response.data.height;
                                        this.signatureWidth = response.data.width;
                                        this.signatureHeight = response.data.height;   
                                    };  
                            }, 10);
                            }
                        })
                        .catch((err) => console.warn(err)); 
            },
            updateResizeSignatureWidth() {
                if (this.resizeSignature.maintainAspectRatio && this.aspectRatioSynchronizing == false) { 
                        this.aspectRatioSynchronizing = true;
                        this.resizeSignature.width = Math.round((this.signatureWidth * this.resizeSignature.height) / this.signatureHeight);  
                        this.aspectRatioSynchronizing = false;
                    }
                },
		    updateResizeSignatureHeight() {
                if (this.resizeSignature.maintainAspectRatio && this.aspectRatioSynchronizing == false) { 
                    this.aspectRatioSynchronizing = true;
                    this.resizeSignature.height = Math.round((this.signatureHeight * this.resizeSignature.width) / this.signatureWidth); 
                    this.aspectRatioSynchronizing = false;
                }
		    },
        },
        filters: 
        {
            limitText(text, maxSize)
            {
                if (!text) return '';
                text = text.toString();

                if (text.length <= maxSize) 
                {
                    return text;
                }

                return text.substr(0, maxSize).trim() + ' ...';
            }
        },
        mounted: function()
        {
            this.getUserSinatures();
            this.GetUserProfessions();
        }
    }
</script>

<style> 
	.ResizeElements .v-skeleton-loader__text {
		height: 35px !important;
	} 
	.ResizeImage .v-skeleton-loader__text {
	    width: 600px;
		margin: auto;
		height: 200px !important;
	}
</style>

<style scoped>
    #signatureModel {
        border: double 3px transparent;
        border-radius: 5px;
        background-image: linear-gradient(white, white),
        radial-gradient(circle at top left, #4bc5e8, #9f6274);
        background-origin: border-box;
        background-clip: content-box, border-box;
        touch-action: auto !important;
    }
    #signatureModel2 {
        border: double 3px transparent;
        border-radius: 5px;
        background-image: linear-gradient(white, white),
        radial-gradient(circle at top left, #4bc5e8, #9f6274);
        background-origin: border-box;
        background-clip: content-box, border-box;
        touch-action: auto !important;
    }
    #done-btn-SM{
        display:none;
    }
    #done-btn-SM2{
        display:none;
    }
    .cropper-SM{
        display:none;
        height:200px !important;
    }
    .cropper-SM2{
        display:none;
        height:200px !important;
    }
    .container {
        width: "100%";
        padding: 8px 16px;
    }
    .buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
        margin-top: 8px;
    }
    .vtooltip {
        background-color: white;
        padding: 5px;
        border-radius: 25px;
    }.report-container .v-input--selection-controls {
        margin-top: 0;
        padding-top: 0;
    }
    .report_header { 
        height: 50px;
        vertical-align: middle; 
        font-weight: 500;
        font-size: 12px;
        letter-spacing: 0.015em;
        color: #667593;
    }
    .report-container .theme--light.v-data-table.v-data-table--fixed-header thead th,  .report-container .v-data-table__wrapper table thead {
        background-color: #FFF;
        box-shadow: none;
    }
    .report-container {
        height: calc(100vh - 116px);
        display: flex;
        flex-direction: column;
        border-radius: 12px !important;
        overflow: auto;
        box-shadow: none !important;
    }
    .report-container .border-top {
        display: flex;
        flex-direction: column;
    }
    .report-container .v-toolbar {
        height: 80px !important;
        padding: 0;
    }
    .report-container .v-toolbar__content {
        height: 100% !important;
        padding: 24px !important;
    }
    img#ItemPreview {
        width: 100px;
        margin: 0.5rem 0;
    }
    .mdi-menu-down {
        filter: brightness(0) saturate(100%) invert(39%) sepia(56%) saturate(232%) hue-rotate(182deg) brightness(102%) contrast(83%) !important ;
    }.v-dialog .v-toolbar__content {
        height: 100% !IMPORTANT;
    }
    .v-input--selection-controls {
        margin-top: 0px !important; 
        padding-top: 0px !important;
    }
    #image-to-crop-SM{width:100%;height:auto !important}
    #image-to-crop-SM2{width:100%;height:auto !important}
    #cropper-SM{width:100%;height:200px !important}
    #cropper-SM2{width:100%;height:200px !important}
    #signatureModel2{
        height:200px !important;
    }
    #signatureModel{
        height:200px !important;
    }
    #signatureCanvas{
        width:100% !important;
        height:0px;
    }
    .upload-control {
        background-color: #f5f5f5 !important;
        border: 1px solid #e0e0e0 !important;
        border-radius: 4px !important;
        cursor: pointer;
    }

    .upload-control:hover {
        background-color: #eeeeee !important;
        border-color: #00ae8d !important;
    }

    .file-preview {
        display: flex;
        align-items: center;
        padding: 4px 8px;
        background-color: #e8f5e9;
        border-radius: 4px;
        margin: 4px 0;
    }

    .v-file-input .v-input__prepend-outer {
        margin-top: 0 !important;
        margin-right: 8px !important;
    }

    .v-file-input .v-input__slot {
        min-height: 40px !important;
        padding: 0 8px !important;
        display: flex !important;
        align-items: center !important;
    }

    .v-file-input .v-input__prepend-outer .v-icon {
        margin-top: 0 !important;
    }
</style> 